module.exports = __webpack_public_path__ + "assets/img/character_ark.44263250.png";